import React from "react";

import { ChartStrings } from "constants/constantStrings";

const ChartNoShowTags =()=> (
  <>
    <div className="no-data-view chart__no-data">
      <label className="dupont-form-label">{ChartStrings.turnOnTags}</label>
      <ul>
        <li className="descriptionText">{ChartStrings.turnOnTagsStep1}</li>
        <li className="descriptionText">{ChartStrings.turnOnTagsStep2}</li>
      </ul>
    </div>
  </>
);

export default ChartNoShowTags;
